const hasSpecChar = str => str.search(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im) !== -1
const hasNumber = str => str.search(/\d/) !== -1
const hasLowerCase = str => str.search(/[a-z]/) !== -1
const hasUpperCase = str => str.search(/[A-Z]/) !== -1

const isValidPassword = pwd => {
  if (pwd.length < 10) return false
  let count = 0
  hasNumber(pwd) && (count++)
  hasLowerCase(pwd) && (count++)
  hasUpperCase(pwd) && (count++)
  hasSpecChar(pwd) && (count++)
  return count >= 3
}

export default isValidPassword
